import React, {useState} from 'react';
import styles from './styles';
import {Form} from '@xpertdox_js/xdcomponents';
import csvFile from '../../../../assets/email-contacts-upload-example.csv';

const ContactsUpload = props => {

  const [formState, setFormState] = useState({});

  const handleFormUpload = e => {
    let csv = '';
    const reader = new FileReader();
    reader.onload = () => {
      csv = reader.result;
      let result = [];
      let rows = csv.split('\n');
      const headers = rows[0].split(',').map(header => header.replace(':', '').toLowerCase().trim());
      rows.shift();
      rows.forEach((row, i) => {
        let formatRow = row.split(',');
        let rowToObject = {};
        formatRow.forEach((val, ii) => {
          rowToObject[headers[ii]] = val ? val.trim() : '';
          if (ii === 0) rowToObject.id = i + '_' + ii + '-' + headers[ii] + '_custom-header';
        })
        result.push(rowToObject);
      })
      props.uploadContacts(result);
    }
    if (e.value[0]) reader.readAsBinaryString(e.value[0]);
  }

  const formSettings = [
    {
      label: 'Upload email contacts via CSV',
      tip: 'test tip',
      type: 'drop',
      id: 'contacts_upload',
      name: 'contacts_upload',
      value: [],
      notRequired: true,
      callback: handleFormUpload,
      labelStyles: {
        height: 'auto',
        padding: '0',
      },
      styles: {
        maxHeight: '165px'
      }
    },
  ]

  return(
    <React.Fragment>
      <p style={styles.uploadContactsDescription}>To upload a list of contacts create a csv file with two headers: <b>Name</b> and <b>Email.</b> <a style={styles.downloadLink} href={csvFile} download>Click Here</a> to download an example of the csv file format.</p>
      <Form
        settings={formSettings}
        state={{formState: formState, setFormState: setFormState}}
        submitable={false}
        returnEvent
      />
    </React.Fragment>
  )
}

export default ContactsUpload;
